import {createSlice, PayloadAction} from '@reduxjs/toolkit'
import {EffectType, InputEnum} from '../../../shared/types/EffectType'


export interface IPromptBase {
    id: number;
    value: string | null;
    isRequired: boolean;
}

export interface IInitialImagePrompt extends IPromptBase {
    type: InputEnum.InitialImage;
}

export interface IOtherPrompts extends IPromptBase {
    type: Exclude<InputEnum, InputEnum.InitialImage>
}


interface GenerationState {
    selectedPreset: EffectType | null
    prompts: [IInitialImagePrompt, ...IOtherPrompts[]]
    previousInitialPhoto: string | null
}

const initialState: GenerationState = {
    selectedPreset: null,
    prompts: [{
        id: 1,
        value: null,
        type: InputEnum.InitialImage,
        isRequired: true,
    }],
    previousInitialPhoto: null,
}

export const generationSlice = createSlice({
    name: 'generation',
    initialState,
    reducers: {
        setSelectedPreset: (state, action: PayloadAction<EffectType | null>) => {
            state.selectedPreset = action.payload
            if (action.payload) {
                state.prompts = action.payload.inputs.map((input) => ({
                    id: input.id,
                    value: input.type === InputEnum.InitialImage && state.previousInitialPhoto
                        ? state.previousInitialPhoto
                        : input.prompt,
                    type: input.type,
                    isRequired: input.isRequired
                }))
            }
        },
        setPromptById: (state, action: PayloadAction<{ id: number, value: string }>) => {
            const selectedPrompt = state.prompts.find((prompt) => prompt.id === action.payload.id)
            if (!selectedPrompt) {
                console.error('Prompt not found ')
                return
            }
            selectedPrompt.value = action.payload.value
            if (selectedPrompt.type === InputEnum.InitialImage) {
                state.previousInitialPhoto = action.payload.value
            }
        },
        clearInitialPhoto: (state) => {
            const intialPhoto = state.prompts.find((prompt) => prompt.type === InputEnum.InitialImage)
            if (!intialPhoto) {
                console.error('Prompt not found ')
                return
            }
            state.previousInitialPhoto  = null
            intialPhoto.value = null

        },

    },
})

export const {setSelectedPreset, setPromptById, clearInitialPhoto} = generationSlice.actions

export default generationSlice.reducer
